<template>
  <header class="header" :class="headerClass">
    <router-link to="/" class="logo__link">
      <img
        v-if="
          headerClass === 'header--start-charging' ||
          headerClass === 'header--charging'
        "
        class="logo header__logo"
        :src="`${config.imagesPath}/logo-light.svg`"
        alt=""
      />
      <picture v-else class="logo">
        <source
          :srcset="`${config.imagesPath}/logo-light.svg`"
          media="(prefers-color-scheme: dark)"
        />
        <img
          :src="`${config.imagesPath}/logo.svg`"
          class="header__logo"
          alt=""
        />
      </picture>
    </router-link>

    <!-- <a
      v-if="headerClass === 'header--charging'"
      class="assistance"
      href="#">
      <img
        src="@/assets/images/assistance.svg"
        alt="">
    </a> -->
    <div class="language-display">
      <div
        class="language-display__display"
        @click="isLanguageSelectorVisible = !isLanguageSelectorVisible"
      >
        <img
          class="language-display__flag"
          :src="`${config.imagesPath}/flag-${selected}.svg`"
          alt=""
        />
        <span class="language-display__country">{{ selected }}</span>
      </div>
      <div v-if="isLanguageSelectorVisible" class="language-selector__items">
        <a
          v-for="(lang, index) in languages"
          :key="index"
          class="language-selector__item"
          href="#"
          @click.prevent="changeLang(lang)"
        >
          <img
            class="language-selector__flag"
            :src="`${config.imagesPath}/flag-${lang}.svg`"
            alt=""
          />
          <span class="language-selector__language">
            {{ $t("common.lang." + lang) }}
          </span>
        </a>
      </div>
    </div>
    <slot />
  </header>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n"
import config from "../../config"
import { ref, watch } from "vue"

interface PageHeaderProps {
  headerClass?: string
}

withDefaults(defineProps<PageHeaderProps>(), {
  headerClass: ""
})

const { availableLocales, locale } = useI18n()

const languages = ref(availableLocales)
const selected = ref(locale)
const isLanguageSelectorVisible = ref(false)

watch(locale, (newValue) => {
  selected.value = newValue
})

const changeLang = (lang: string) => {
  locale.value = lang
  selected.value = locale.value
  isLanguageSelectorVisible.value = false
}
</script>
